export default __webpack_public_path__ + "42f248a935f0583a3ac63d0248a8ab02.png";